import {App} from './app';
import 'firebase/auth';

export const Auth = App.auth();

Auth.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = Auth.onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        }, reject);
    })
};